import { ExpandableList } from '@ipfabric/ui-components/List/ExpandableList/ExpandableList';
import { ListDivider } from '@ipfabric/ui-components/List/ListDivider/ListDivider';
import { MenuItemsColumn } from '@ipfabric/ui-components/MenuItem/MenuItemsColumn';
import type { date } from '@ipfabric/utils';
import type { FC } from 'react';
import React from 'react';
import type { AppTranslations } from 'translations/translations';
import { SnapshotItem } from './SnapshotItem';
import type { SnapshotsSection } from './SnapshotTypes';

type Props = {
  section: SnapshotsSection;
  isOpen: boolean;
  selectedSnapshot?: string[] | null;
  onSectionToggle: () => void;
  onSelectSnapshot: (snapshotId: string, event: React.MouseEvent) => void;
  msg: AppTranslations['snapshotManagement'];
  defaultSnapshotName: string;
  dateTimeFormat: string;
  timezone: date.Timezone;
};

export const SnapshotSection: FC<Props> = (props) => {
  return (
    <React.Fragment key={props.section.title}>
      <ListDivider />
      <ExpandableList
        key={props.section.title}
        label={props.section.title}
        size='default'
        badge={
          props.isOpen ? undefined : props.section.snapshots.length.toString()
        }
        opened={props.isOpen}
        onToggle={props.onSectionToggle}
        content={
          <MenuItemsColumn>
            {props.section.snapshots.map((snapshot) => (
              <SnapshotItem
                key={snapshot.id}
                snapshot={snapshot}
                selected={
                  props.selectedSnapshot?.includes(snapshot.id ?? '') ?? false
                }
                onSelect={props.onSelectSnapshot}
                msg={props.msg}
                dateTimeFormat={props.dateTimeFormat}
                timezone={props.timezone}
                defaultSnapshotName={props.defaultSnapshotName}
              />
            ))}
          </MenuItemsColumn>
        }
      />
    </React.Fragment>
  );
};
